import React,{useState,useEffect} from 'react';
import { key, reprogramacion1 } from '../../../../Images/Images';
import SelectComponent from '../../Others/SelectComponent';
import {AgentButton,useToasts} from 'global-components-library';
import { Singleton } from '../../../../js/Singleton';
import { useDispatch, useSelector } from 'react-redux';
import {  removeRecord,setPhoneToCallPerRec, changePreviewRecordStatus, setSelectedRecord, setMaximumAssignmentPreview, setWasItwasSentPreviewTime,resetRecordPreview, setDialogTimeSimultaneousView } from '../../../../redux/actions/A_preview';
import { getCurrentTimeInSec } from '../../../../js/helpers/Utils/formats';
import { manualCall, actionPreviewRecord, messageApiRequest } from '../../../../redux/actions/A_messages_to_SM';
import A_Alert_Modal from '../../../../redux/actions/A_Alert_Modal';
import { SingletonSharedData } from '../../../../js/singletonSharedData';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle';
import { messageHangUp } from '../../../../redux/actions/A_messages_to_SM';
import { API_ENDPOINTS, HANG_UP_SUBACTIONS } from '../../../../constants';
import { RECORD_STATE } from '../../../../constants';
import { useMemo } from 'react';
import TimerCardPreview from './TimerCardPreview';
import { errorsMessagePreviewSR } from '../../../../js/Strategies/Strategies_Preview_RecState';
import { ACTION_CALL_ACD } from '../../../../constants';
import { callAction } from '../../../../redux/actions/A_reducer_call_acd';
import { Logger } from '../../../../js/helpers/Logger';


const language = new Singleton();
const { showAlertModal } = A_Alert_Modal.creators;
const sharedData = new SingletonSharedData()
const  APIFact = new APIFactory();
const apiCont = APIFact.buildClient();

const CardPreviewRecord=({ record, data1, data2, defaultDialingRate})=> {
    const { phoneToCall,callKey,campaignName,phones,camId, initialTimeSec, previewTime, callOutId, status, callId, 
        maximumAssignments,itWasSentTimeInPreview,dialogTime,dispositionData:{alreadyRated, exitPreview}, remainingTime} = record;
    const { records, fReplacementJob, selectedRecord, isSomeRecInDialog, countRecordsDialing,switchBetweenHold, switchBetweenWrapUp,ndScheduled} = useSelector(state => state.preview);
    const {transferInProgress,unnasignByXfer,acceptedTransfer} = useSelector(state => state.previewActions)
    const [objectPhones,setObjectPhones] = useState([]);
    const [numbersList,setNumbersList] = useState([]);
    const [displayedComponent,setDisplayedComponent]= useState('1'); 
    const [phone, setPhone] = useState(phoneToCall);
    const [borderColor, setBorderColor]=useState('');


    const [labelTimer, setLabelTimer] = useState(language.getText('GUIPreviewtimePreviewMode'))
    const [disableBtns, setDisableBtns] = useState(false);
    const [disableBtnCall, setDisableBtnCall] = useState(false);
    const [disableBtnHoldAndResume, setDisableBtnHoldAndResume] = useState(false);
    const [disableBtnHangUp, setDisableBtnHangUp] = useState(false);
    const [showBtnDiscart,setShowBtnDiscart]=useState(record.previewDiscard);
    const [showBtnDelete,setShowBtnDelete] =useState(record.permissionDelete);
    const [showBtnCall, setShowBtnCall]=useState(true);
    const [showBtnHangup, setShowBtnHangup] = useState(false);
    const [showBtnHoldAndResume, setShowBtnHoldAndResume] = useState(false);

    const [iTimeSec, setITimeSec] = useState(initialTimeSec);
    const [timeInPreview, setTimeInPreview] = useState(0);
    const [isSaveTimeInPreview,setIsSaveTimeInpreview ] = useState(false)
    /////////-------------------newTimer
    const [resetTimerxDisp, setResetTimerxDisp ] = useState(false);  
    const wrapUp = [RECORD_STATE.WRAPUP, RECORD_STATE.ABANDONED, RECORD_STATE.ALERT]
    const dispatch = useDispatch();
    const { addToast } = useToasts();


    useEffect(() => {
        let numbers = phones.map(function(dato, i) {
            return {id: i, img: reprogramacion1,number:dato};
        });
        setObjectPhones(numbers);
        setTimeout(() => {
			dispatch(messageApiRequest(API_ENDPOINTS.CALL_OUT_CAMPAIGNS, '', true));
		}, 100);
    }, []);
    
    useEffect(() => {
        if(status!== RECORD_STATE.DIALOG)
        {   
            stopStartTimeWhileIsCalling()
        }
    
    }, [countRecordsDialing])
    
    useEffect(() => {
        if(objectPhones.length > 0 && numbersList.length === 0){
            setNumbersList(objectPhones);
        }
    }, [objectPhones]);

    useEffect(() => {
        selectedRecord.callOutId === callOutId ? setBorderColor('cpr-selected') : setBorderColor('');
    }, [selectedRecord.callOutId]);

    useEffect(() => {
        if(isSomeRecInDialog || ndScheduled)
        {
            setDisableBtnCall(true)
        }
        else{
            defaultDialingRate === countRecordsDialing ? setDisableBtnCall(true) : setDisableBtnCall(false);
        }
        resetRecordIfAlertisCancelled()
    }, [countRecordsDialing,isSomeRecInDialog,ndScheduled])

    useEffect(() => { 

        cardDesign();

    }, [status]);

    useEffect(() => {
      if(status === RECORD_STATE.DIALOG && dialogTime !== undefined)
      {
        validateDisposition();
      }else if(status === RECORD_STATE.DEFAULT && dialogTime !== undefined)
      {
        dispatch(setDialogTimeSimultaneousView({callOutId: callOutId, dialogTime: undefined}))

      }
    }, [status,dialogTime])
    
        
    useEffect(() => {
        if(sharedData.callOutCampaigns ){
            const campaigns = Object.values(sharedData.callOutCampaigns)
            if(callOutId){
                if(maximumAssignments < 0){
                    const campaign = campaigns.find(campaign => campaign.ID === camId)
                    const maxAssign = campaign!== undefined && campaign.TimesPreview > 0 ?  campaign.TimesPreview : 1;
                    dispatch(setMaximumAssignmentPreview({callOutId: callOutId, maximumAssignments:  maxAssign}))
                }
            }
            
        }
    }, [sharedData.callOutCampaigns]);

    useEffect(() => {
        if(status === RECORD_STATE.DEFAULT && maximumAssignments === 0){
            dispatch(actionPreviewRecord({process:16, camId:camId, callOutId:callOutId,previewTime: 0, callId:0,fMultipleJob: 1 , fReplacementJob: 0}));
            dispatch(removeRecord( callOutId));
        }
    }, [maximumAssignments, status]);   
    
    const cardDesign = () => {
        switch (status) {
            case RECORD_STATE.TIME_OVER:
                cardDesignOnTimeOver()
                break;

            case RECORD_STATE.DIALOG:
                !itWasSentTimeInPreview && sendTime();
                selectRecord()
                cardDesignDialog()
                break;

            case RECORD_STATE.DIALING:
                cardDesignDialing()
                break;

            case RECORD_STATE.WRAPUP:
                case RECORD_STATE.WAITING_WRAPUP:
                cardDesignWrapUp();
                break

            case RECORD_STATE.HOLD:
                cardDesignHold()
                break;

            case RECORD_STATE.ALERT:
                sendTime();
                cardDesignAlert()            
                break;

            case RECORD_STATE.DEFAULT:
                cardDesignDefault()
                break;
            case RECORD_STATE.ABANDONED:
                cardDesingAbandoned()
                break;
            default:
                dispatch(changePreviewRecordStatus({callOutId:callOutId, status: RECORD_STATE.DEFAULT}))
                break;
            };
    }
    useEffect(() => {
      if(status === RECORD_STATE.HOLD && disableBtnHoldAndResume !== transferInProgress)
      {
        setDisableBtnHoldAndResume(transferInProgress)
      }
    }, [transferInProgress,status])

    useEffect(() => {
      if(unnasignByXfer)
      {
        setTimeout(() => {
            let time = getCurrentTimeInSec()-iTimeSec +timeInPreview;
            dispatch(actionPreviewRecord({ process:4, camId: camId, callOutId: callOutId, previewTime: time, callId: callId}));
        }, 50);
        dispatch(removeRecord(callOutId))
      }
    }, [unnasignByXfer])
    
    
    const selectPhone = (p) =>{
        setPhone(p.number);
    }

    const setTimeLeft =() =>{
        let time = countRecordsDialing>0 ? previewTime - timeInPreview : previewTime -(getCurrentTimeInSec()-iTimeSec +timeInPreview);
        return time;
    }

 
    const cardDesignOnTimeOver=() =>{
        dispatch(changePreviewRecordStatus({callOutId:callOutId, status:RECORD_STATE.TIME_OVER}))
    }
    const cardDesignDialing=()=>{
        setLabelTimer(language.getText('GUIPreviewmax-dialing-time'))
        setDisableBtns(true);
        setShowBtnDiscart(false);
        setShowBtnCall(true)
        setShowBtnHangup(true);
        setShowBtnHoldAndResume(false);
        setShowBtnDelete(false);
        
    }
    const cardDesignHangUp=()=>{
        setDisableBtnHangUp(true);
    }
    const cardDesignDialog =() =>{
        setLabelTimer(language.getText('GUIPreviewengagedTimer'))
        setShowBtnDiscart(false);
        setShowBtnDelete(false);
        setShowBtnCall(false);
        setShowBtnHangup(true);
        setShowBtnHoldAndResume(true)
    }
    const cardDesignHold=()=>{
        setLabelTimer(language.getText('GUIPreviewengagedTimer'))
        setShowBtnCall(false);
        setShowBtnDiscart(false);
        setShowBtnDelete(false)
        setShowBtnHangup(true);
        setShowBtnHoldAndResume(true)
    }
    const cardDesignAlert=()=>{
        setDisableBtnCall(true);
        setShowBtnHangup(false);
    }

    const cardDesignDefault=()=>{
        setDisableBtnHangUp(false);
        setLabelTimer(language.getText('GUIPreviewtimePreviewMode'));
        setDisableBtns(false);
        setShowBtnDiscart(record.previewDiscard);
        setShowBtnCall(true)
        setShowBtnDelete(record.permissionDelete);
        setShowBtnHangup(false);
        setShowBtnHoldAndResume(false);
        (ndScheduled || isSomeRecInDialog) ? setDisableBtnCall(true) : setDisableBtnCall(false);
        setResetTimerxDisp(false);
    }

    const cardDesignWrapUp=()=>{
        setLabelTimer(language.getText('GUIPreviewengagedTimer'))
        setDisableBtns(false);
        setShowBtnDiscart(record.previewDiscard);
        setShowBtnCall(true)
        setShowBtnDelete(record.permissionDelete);
        setShowBtnHangup(false);
        setShowBtnHoldAndResume(false);
        setDisableBtnCall(true);
    }
    const cardDesingAbandoned = () => {
        setLabelTimer(language.getText('GUIPreviewengagedTimer'))
        setDisableBtnHoldAndResume(true);
        setDisableBtnHangUp(true);
        setShowBtnHangup(true);
        setShowBtnHoldAndResume(true);
        abandonedRec(language.getText('GUIPreviewcallAbandonedMssg').replace('[n]',`[${phoneToCall}]`))
    }

    const actionCall = () => {
        Logger.Info("[CardPreviewRecord][actionCall] => ", JSON.stringify({callKey,callId , status, process, record }));

        status === RECORD_STATE.DIALOG ? holdOrResume() : callPreview();
    }

    const holdOrResume = () => {
        dispatch(actionPreviewRecord({process:11, camId:camId, callOutId:callOutId,previewTime:previewTime,callId:0, fMultipleJob: records.length === 1 ? 0 : 1 , fReplacementJob: fReplacementJob}))
    }

    const callPreview = () => {
        let time = setTimeLeft()
        dispatch(changePreviewRecordStatus({callOutId:callOutId, status:RECORD_STATE.DIALING, remainingTime:time}))
        dispatch(setPhoneToCallPerRec({callOutId: callOutId, phone: phone}))
       
        let data = {
          CamId: camId, CallKey: callKey, 
          Phone: phone,Data: "", ExistsCallout: callOutId, CallMode: 0, integration:false
        };
        setTimeout(() => {
            dispatch(manualCall(data));
        }, 100);
    }

    const discard = () => {
        Logger.Info("[CardPreviewRecord][discard] => ", JSON.stringify({callKey,callId , status, process, record }));
        let timeout = sharedData.getRequestTimeout();
        let userId = sharedData.getParameters().UserID;
        let acdId = 1
        let objectResponseTransfer = apiCont.getObjectResponse();

        apiCont.transferCall(userId, acdId, objectResponseTransfer, timeout);
        objectResponseTransfer.onError = function (messageError) {
            Logger.Error('[CardPreviewRecord][discard]',messageError)
        };
        objectResponseTransfer.onSuccess = function  (objectResponseTransfer) {  
            dispatch(showAlertModal({
              type: "ModalAlert",
              title: language.getText('GUIPreviewunassignRecordTitle'),
              message: language.getText('GUIPreviewunassignRecordBody'),
              button:language.getText('GUIPreviewcancel'),
              secondButton: language.getText('GUIPreviewconfirmUnassign') ,
              secondButtonFtn: () =>{
                sharedData.setAgentList(objectResponseTransfer.AgentesList)
                processDeleteDiscard(0)   
              } 
            }));
        } 
    }
    
    const deleteRecord = () => {
        dispatch(showAlertModal({
            type: "ModalAlert",
            title: language.getText('GUIAlertMessagedeletePreviewRecord'),
            message: language.getText('GUIAlertMessagemsgDeletePreviewRecord'),
            button: language.getText('GUIAlertMessagecancel'),
            secondButton: language.getText('GUIPreviewdelete'),
            secondButtonFtn: () => processDeleteDiscard(1)
        }));
    }

    const processDeleteDiscard = (process) =>{
        Logger.Info("[CardPreviewRecord][processDeleteDiscard] => ", JSON.stringify({callKey,callId , status, process, record }));

        let time = getCurrentTimeInSec()-iTimeSec +timeInPreview;
        setTimeout(() => {
            dispatch(actionPreviewRecord({process:process, camId:camId, callOutId:callOutId,previewTime: time,callId:0, fMultipleJob: records.length === 1 ? 0 : 1 , fReplacementJob: fReplacementJob}));
        },100);
        dispatch(removeRecord(callOutId))
    }
    const resumeAndHold=()=>{
        if(status === RECORD_STATE.DIALOG)
        {
            dispatch(callAction(ACTION_CALL_ACD.HOLD,{},callOutId));
            dispatch(changePreviewRecordStatus({callOutId:callOutId, status:RECORD_STATE.HOLD})) 

        } else if(status === RECORD_STATE.HOLD)
        {
            hold();
        }
    }
    const hold=()=>{
        Logger.Info("[CardPreviewRecord][hold] => ", JSON.stringify({callKey, callId , status, process, record }));
        let recordInDialog=(records.find(r=>r.status === RECORD_STATE.DIALOG));
        if(recordInDialog === undefined)
        {
            dispatch(callAction(ACTION_CALL_ACD.HOLD,{},callOutId));
        }else
        {
            if(recordInDialog.callOutId === callOutId)
            {
                dispatch(callAction(ACTION_CALL_ACD.HOLD,{},callOutId));
    
            }else
            {
                setTimeout(() => {
                    dispatch(actionPreviewRecord({ process:11, camId: camId, callOutId: callOutId, previewTime: 0, callId: callId}));
                }, 50);
            }

        }
        dispatch(changePreviewRecordStatus({callOutId:callOutId, status:RECORD_STATE.DIALOG}))
    }
    
    const hangup =()=>{
        Logger.Info("[CardPreviewRecord][hangup] => ", JSON.stringify({callKey,callId ,status, record }));

        cardDesignHangUp();
        (status === RECORD_STATE.DIALOG || status === RECORD_STATE.HOLD)
        ? 
        setTimeout(() => {
            dispatch(messageHangUp(HANG_UP_SUBACTIONS.CALL,callOutId)) 
        }, 100)
        :
        setTimeout(() => {
            dispatch(messageHangUp(HANG_UP_SUBACTIONS.MANUAL_CALL,callOutId))
        }, 100)
        validateDisposition();        
    }
    const validateDisposition = () =>{
        if(alreadyRated && exitPreview) {
            dispatch(removeRecord(selectedRecord.callOutId));
        } else if(alreadyRated && !exitPreview)
        {
            resetRecord();
        }
       
    }
    
    const resetRecord=()=>{
        Logger.Info("[CardPreviewRecord][resetRecord] => ", JSON.stringify({callKey,callId ,status, record }));

        let temp = maximumAssignments - 1
        dispatch(setWasItwasSentPreviewTime({callOutId: callOutId,itWasSent:false}))
        dispatch(setMaximumAssignmentPreview({callOutId: callOutId, maximumAssignments: temp}))
        setTimeout(()=>{
            const replacement = temp === 0 ? fReplacementJob : 0;
            dispatch(actionPreviewRecord({process:5, camId:record.camId, callOutId:callOutId,previewTime: previewTime, callId:0, fMultipleJob: records.length === 1 ? 0 : 1 , fReplacementJob: replacement}));
        },100)
        dispatch(resetRecordPreview(callOutId));
    }

    const selectRecord = () =>{
        dispatch(setSelectedRecord(callOutId))
    }

    const sendTime = () => {
        let time = getCurrentTimeInSec()-iTimeSec +timeInPreview;
        if((status === RECORD_STATE.ALERT && record.messageStatus === '1512'))
        {
            setTimeout(() => {
            dispatch(actionPreviewRecord({ process:13, camId: camId, callOutId: callOutId, previewTime: time, callId: callId})); 
            }, 50);
            
        } else if(status === RECORD_STATE.DIALOG && !itWasSentTimeInPreview)
        {
            setTimeout(() => {
            dispatch(actionPreviewRecord({ process:7, camId: camId, callOutId: callOutId, previewTime: time, callId: callId}));
            }, 50);
        }
        dispatch(setWasItwasSentPreviewTime({callOutId:callOutId, itWasSent:true}));
    }
    
    const stopStartTimeWhileIsCalling = () =>{
        if(countRecordsDialing > 0  && !isSaveTimeInPreview)
        {
            let tempT=  getCurrentTimeInSec() - iTimeSec;
            setTimeInPreview(tempT+timeInPreview);  
            setIsSaveTimeInpreview(true);      
        }
        else if(countRecordsDialing === 0 )
        {
            setIsSaveTimeInpreview(false);
            setITimeSec(getCurrentTimeInSec());
        }
    }
    const resetRecordIfAlertisCancelled = () => {
        if(status === RECORD_STATE.ALERT && (!isSomeRecInDialog && countRecordsDialing === 0)&& (record.messageStatus === '1512' || record.messageStatus === '1508'))
        {
            dispatch(resetRecordPreview(callOutId));
        }        
    }
    const messageResponseCard = useMemo(() => {
        return errorsMessagePreviewSR(record.messageStatus)
    },[record.messageStatus])

    const abandonedRec = message => {
        addToast(message, {
            group: 'icon', 
            position: 'topRight',
            icon: 'warning', 
            color: 'yellow', 
            btnComponent: <AgentButton type='tertiary'>{language.getText("GUIAlertMessageclose")}</AgentButton>,
            timeout: 5000, 
        });
    };

    return (
        <div className={`cpr-container ${status} ${borderColor}`} onClick={(!isSomeRecInDialog || (switchBetweenHold && status === RECORD_STATE.HOLD) || (switchBetweenWrapUp && wrapUp.includes(status) && !wrapUp.includes(selectedRecord.status))) && selectRecord}> 
            <div className='cpr-infoContainer'>
                <div className='cpr-dataContainer'>
                    <div className='cpr-callKeyContainer'>
                        <div className='cpr-callKeyIcon'>
                            <img src={key} alt='icon'/>  
                        </div>
                        <p className='cpr-callKey'>{callKey}</p>
                    </div>
                    
                    <p className='cpr-campaingName'>{campaignName}</p>
                    <div className='cpr-dataContainer'>
                        <p className='cpr-data'>{data1}</p>
                        <p className='cpr-data'>{data2}</p>
                    </div>
                </div>
                <div className='cpr-campInfoContainer'>
                    <TimerCardPreview  
                            fReplacementJob={fReplacementJob} 
                            cardDesignOnTimeOver={cardDesignOnTimeOver} 
                            record={record} 
                            labelTimer={labelTimer}
                            resetTimerxDisp={resetTimerxDisp}
                    />
                    <div className="cpr-selectPhoneContainer">
                    { numbersList.length>0 && 
                    <SelectComponent
                        
                        bottomBox={60}
                        defaultDiv={{ item: "texSelection" }}
                        displayer={"bigDisplayer"}
                        customCell={"cellImageText"}
                        parameters={{ image: "img", text: "number" }}
                        dataSource={numbersList}
                        closeOthers={true}
                        itemDefault={0}
                        displayedList={displayedComponent}
                        onSelectItem={selectPhone} />}
                    </div>
                    {
                        messageResponseCard &&
                        (<div className="cpr-status-call">
                            <p> 
                                {messageResponseCard}
                            </p>
                        </div>)
                    
                    }
                </div>
            </div>
            <div className='cpr-btnContainer'>
                {
                    showBtnDiscart && 
                    <div className='cpr-styleBtn'>
                        <AgentButton type='secondary' color={'blue'} icon={'discart'} disabled={disableBtns} onClick={discard}>
                            {language.getText('GUIPreviewdiscard')}
                        </AgentButton>
                    </div>    
                } 
                {
                    showBtnCall &&
                    <div className='cpr-styleBtn'>
                        <AgentButton type='primary' color={`green ${status === RECORD_STATE.DIALING ? 'v2' :''}`} icon={`${status === RECORD_STATE.DIALING ? 'dialing' : 'call'}`} disabled={disableBtnCall || disableBtns} onClick={actionCall}>
                        {status === RECORD_STATE.DIALING ? language.getText('GUIPreviewdialing'): language.getText('GUIPreviewdial')}
                        </AgentButton>
                    </div>
                }
                {
                    showBtnDelete &&
                    <div className='cpr-styleBtn'>
                        <AgentButton type='secondary' color={'red'} icon={'trash'} disabled={disableBtns} onClick={deleteRecord}>
                            {language.getText('GUIPreviewdelete')}
                        </AgentButton>
                    </div>
                }
                {
                    showBtnHoldAndResume && 
                    <div className='cpr-styleBtn'>
                        <AgentButton type='primary' color={'green'} icon={`${status === RECORD_STATE.DIALOG ? 'hold' : 'resume'}`} disabled={disableBtnHoldAndResume} onClick={resumeAndHold}>
                            {status === RECORD_STATE.DIALOG ? language.getText('GUIPreviewhold') : language.getText('GUIPreviewresume')}
                        </AgentButton>
                    </div>
                }
                {
                    showBtnHangup && 
                    <div className='cpr-styleBtn'>
                        <AgentButton type='secondary' color={'red'} icon={'call-out'} disabled={disableBtnHangUp} onClick={hangup}>
                            {language.getText('GUIPreviewhangup')}
                        </AgentButton>
                    </div>
                }
            </div>
        </div>
    )
    
}

export default CardPreviewRecord;


// WEBPACK FOOTER //
// ./src/components/workSpace/SimultaneosRecsPreview/CardPreviewRecord/CardPreviewRecord.jsx